module.exports = __webpack_public_path__ + "img/select-right.5b6e70fd.svg";